import { Modal } from '@jouzen/ecom-components/v3/Modal';

import Video from '@/app/components/Video/Video';

import { useSizingPageModalContext } from '../contexts/SizingPageModalProvider';

const Gen4VideoModal = () => {
  const { or4VideoVisible, setOr4VideoVisible } = useSizingPageModalContext();
  const toggleModal = () => {
    setOr4VideoVisible(false);
  };

  return (
    <Modal
      isOpen={or4VideoVisible}
      onOpenChange={toggleModal}
      padding="large"
      size="large"
    >
      <div className="px-6 xl:px-24">
        <div className="aspect-video" data-cy="gen4-sizing-video-wrapper">
          <Video
            captions={[
              { lang: 'cs', src: 'or4-sizing-cs.vtt' },
              { lang: 'da', src: 'or4-sizing-da.vtt' },
              { lang: 'de', src: 'or4-sizing-de.vtt' },
              { lang: 'en', src: 'or4-sizing-en.vtt' },
              { lang: 'es', src: 'or4-sizing-es.vtt' },
              { lang: 'fi', src: 'or4-sizing-fi.vtt' },
              { lang: 'fr', src: 'or4-sizing-fr.vtt' },
              { lang: 'it', src: 'or4-sizing-it.vtt' },
              { lang: 'ja', src: 'or4-sizing-ja.vtt' },
              { lang: 'nb', src: 'or4-sizing-nb.vtt' },
              { lang: 'nl', src: 'or4-sizing-nl.vtt' },
              { lang: 'sv', src: 'or4-sizing-sv.vtt' },
            ]}
            className="size-full"
            contentTitle="or4_sizing_video"
            hasLocalizedAudio
            location="sizing-hero"
            localizedSrc="sizing_gen4_sizing_video_src"
            playVideo={or4VideoVisible}
            preload="metadata"
            type="video/mp4"
            posterSrc="sizing/video-poster.png"
          />
        </div>
      </div>
    </Modal>
  );
};

export default Gen4VideoModal;
